import vSelect from 'vue-select';
import SingleProductsList from './SingleProductsList/SingleProductsList.vue';

export default {
  name: 'ProductsList',
  components: {
    SingleProductsList,
    'v-select': vSelect,
  },
  props: {
    products: { type: Array },
    selectedProducts: { type: Array },
    disabled: Boolean,
  },
  mounted() {
    this.normalizeProducts();
  },
  data() {
    return {
      coverageProducts: [],
      serviceProducts: [],
    };
  },
  watch: {
    products() {
      this.normalizeProducts();
    },
    selectedProducts() {
      this.normalizeProducts();
    },
  },
  methods: {
    updateProducts(newProduct) {
      this.$emit('update:selectedProducts', newProduct);
    },
    updateIsValidRcfValue(isValidRcfValue) {
      this.$emit('update:isValidRcfValue', isValidRcfValue);
    },
    classifyProducts(normalizedContractedProducts) {
      normalizedContractedProducts.sort((product) => product.position);
      this.coverageProducts = normalizedContractedProducts.filter(
        (product) => !product.isService,
      );
      this.serviceProducts = normalizedContractedProducts.filter(
        (product) => product.isService,
      );
    },
    getInputSelectContractedProducts() {
      const inputSelectProducts = this.products.filter(
        (product) => product.input === 'select',
      );
      const inputSelectGroupings = [
        ...new Set(inputSelectProducts.map((product) => product.grouping)),
      ];

      const inputSelectContractedProducts = [];

      inputSelectGroupings.forEach((grouping) => {
        const productsInGrouping = inputSelectProducts
          .filter((product) => product.grouping === grouping)
          .map((product) => {
            const selectedProduct = this.selectedProducts.find(
              (selectedProduct) => product.id === selectedProduct.id,
            );
            return {
              ...product,
              quantity: selectedProduct ? selectedProduct.quantity : 0,
              label: product.values.franchise
                ? `${
                    product.optionName
                  } de R$ ${product.values.franchise.toLocaleString('pt-BR')}`
                : product.optionName,
            };
          });

        const { productName, isService, input, position, description } =
          productsInGrouping[0];
        inputSelectContractedProducts.push({
          grouping,
          productName,
          options: [...productsInGrouping],
          isService,
          input,
          position,
          description,
        });
      });
      return inputSelectContractedProducts;
    },
    getInputSliderContractedProducts() {
      const inputSliderProducts = this.products.filter(
        (product) => product.input === 'slider',
      );
      const inputSliderContractedProducts = inputSliderProducts.map(
        (product) => {
          const selectedProduct = this.selectedProducts.find(
            (selectedProduct) => selectedProduct.id === product.id,
          );

          if (selectedProduct)
            return { ...product, quantity: selectedProduct.quantity };
          return { ...product, quantity: product.min || 0 };
        },
      );
      return inputSliderContractedProducts;
    },
    normalizeProducts() {
      if (!this.selectedProducts || !this.products) return;
      const inputSelectContractedProducts =
        this.getInputSelectContractedProducts();
      const inputSliderContractedProducts =
        this.getInputSliderContractedProducts();

      const normalizedContractedProducts = [
        ...inputSelectContractedProducts,
        ...inputSliderContractedProducts,
      ];
      this.classifyProducts(normalizedContractedProducts);
    },
  },
};
